import React, { FC, useCallback, useEffect, useState, useReducer, useContext } from "react";
import { IAssessment, IState, IAssessmentTemplateDetail, IAssessmentProject, IControlMeasureConcern, IProjectUser, ISummaryTotalKnowledge, IDam, IControlMeasureAdequacy, ISummaryKnowledge, IAssessmentTemplateGroup, IDocument, IInvestigationAssessment, IRiskAssessment, ISeverity, IHarm, IInvestigation, IError, IControlType, ICriticalHazards, IFailureMode, IUpload, IDamsList, IControlMeasureCost, IDataGap, IAdequacy, IControlMeasure, IControlMeasureAssessment, IProjectFailureMode, IFailureModeAssessment, IControlMeasureFailureMode, IConsequenceCategory, ICommentThread, IAssessmentSettings } from "../types/types";
import { get, post, postv2, upload } from "../fetchers/fetchers";
import { Button, Card, CardActions, CardContent, Grid } from "@material-ui/core";
import { TasksContext, TasksDispatchContext, TasksProvider } from './context';
import { useParams } from "react-router";
import { API_URL } from "../env";
import { APPLICATION } from "../env";



interface IRouteParams {
    id: string
}


export const get_query = (): {[key: string]: string} => {

    // get query params
    const urlParams = new URLSearchParams(window.location.search);
    const state = urlParams.get('state') as string


    let query: {[key: string]: string} = {}
    // get state from local storage

    if (state) {
        query = {"state": state}
    }   

    return query
}

const get_access = (): string => {
        // get query params
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.get('access') as string
}

// Get a list of all the dams and write it to the conxtent
export const getDataGaps = async (params:string, dispatch:any) => {
    // load query from local storage
    
    
    const d = await get<IDataGap[]>(API_URL + "summary_assessment/" + params + "/data_gap", get_query());
    dispatch({
        type: 'set_data_gap',
        data: d
    })
}

export const getControlTypes = async (dispatch:any) => {
    const d = await get<IControlType[]>(API_URL + "control_measures/control_types/");

    dispatch({
        type: 'set_controlTypes',
        data: d
    })

}

export const  getAssessmentTemplates = async (project_id: number, dispatch:any) => {
    const templates = await get<IAssessmentTemplateDetail[]>(API_URL + "assessment_templates/details/"+ project_id +"/");

    let app_id = APPLICATION == "SFAIRP" ? 1 : 2

    // remove template where assessment_type_id is not equal to app_id 
    const filtered = templates.filter((template) => (template.template.assessment_type_id || app_id) === app_id )

    dispatch({
        type: 'set_assessmentTemplates',
        data: filtered
    })
}

export const getControlMeasures = async (params:string, dispatch:any) => {
    const d = await get<IControlMeasure[]>(API_URL + "control_measures/" + params + "/", get_query());

    dispatch({
        type: 'set_controlMeasures',
        data: d
    })


}

export const getFailureModes = async (params:string, dispatch:any) => {
    const d = await get<IProjectFailureMode[]>(API_URL + "failure_modes/" + params.toString(), get_query());

    dispatch({
        type: 'set_failureModes',
        data: d
    })
}




export const getFailureModeControlMeasures = async (params:string, dispatch:any) => {
    const d = await get<IControlMeasureFailureMode[]>(API_URL + "control_measures/" + params.toString() + "/failure_modes", get_query());


    dispatch({
        type: 'set_failureModeControlMeasures',
        data: d
    }) 
}

export const getFailureModeAssessments = async (params:string, dispatch:any) => {
    const d = await get<IFailureModeAssessment[]>(API_URL + "failure_modes/" + params + "/assessment", get_query() );

    dispatch({
        type: 'set_failureModeAssessments',
        data: d
    })

}

export const getAssessmentSettings = async (params:string, dispatch:any) => {
    const d = await get<IAssessmentSettings>(API_URL + "assessment_project/" + params + "/settings", get_query());

    dispatch({
        type: 'set_assessment_settings',
        data: d
    })
}

export const getAdequacies = async (dispatch:any) => {
    const d = await get<IAdequacy[]>(API_URL + "assessment_templates/adequacies");

    let app_id = APPLICATION == "SFAIRP" ? 1 : 2

    // remove template where assessment_type_id is not equal to app_id 
    const filtered = d.filter((d) => (d.assessment_type_id || app_id) === app_id )


    dispatch({
        type: 'set_adequacies',
        data: filtered
    })


}

export const getControlMeasureAdequacy = async (params:string, dispatch:any) => {
    const d = await get<IControlMeasureAdequacy[]>(API_URL + "control_measures/" + params + "/control_measure_adequacy", get_query());

    dispatch({
        type: 'set_controlMeasureAdequacy',
        data: d
    })
}

export const getControlMeasureConcern = async (params:string, dispatch:any) => {
    const d = await get<IControlMeasureConcern[]>(API_URL + "control_measures/" + params + "/control_measure_concern", get_query());

    dispatch({
        type: 'set_controlMeasureConcern',
        data: d
    })
}


export const getControlMeasureAssessment = async (params:string, dispatch:any) => {
    const d = await get<IControlMeasureAssessment[]>(API_URL + "control_measures/" + params.toString() + "/assessments", get_query());

    dispatch({
        type: 'set_controlMeasureAssessments',
        data: d
    })
}

export const getControlMeasureCosts = async (params:string, dispatch:any) => {
    const d = await get<IControlMeasureCost[]>(API_URL + "control_measures/" + params.toString() + "/costs", get_query());

    dispatch({
        type: 'set_controlMeasureCosts',
        data: d
    })
}



export const getCriticalAssessments = async (params:string, dispatch:any) => {
    const d = await get<ICriticalHazards[]>(API_URL + "critical_hazards/" + params + "/", get_query());
    // setRiskAssessments(assessments)

    dispatch({
        type: 'set_criticalHazards',
        data: d
    })


}

export const getSeverities = async (dispatch:any) => {
    const d = await get<ISeverity[]>(API_URL + "severity/");

    dispatch({
        type: 'set_severity',
        data: d
    })
}

export const getInvestigations = async (params:string, dispatch:any) => {
    const d = await get<IInvestigation[]>(API_URL + "investigations/" + params + "/", get_query());

    dispatch({
        type: 'set_investigations',
        data: d
    })

}

export const getInvestigationAssessment = async (params:string, dispatch:any) => {
    const d = await get<IInvestigationAssessment[]>(API_URL + "investigations/" + params + "/investigation_assessment", get_query());
    // setInvestigationAssessments(assessments)

    dispatch({
        type: 'set_investigationAssessments',
        data: d
    })

}

export const getCriticalRiskAssessments = async (params:string, dispatch:any) => {
    const d = await get<IRiskAssessment[]>(API_URL + "risk_assessments/" + params + "/risk_assessment", get_query());

    dispatch({
        type: 'set_criticalRiskAssessments',
        data: d
    })
}



export const getHarms = async (params:string, dispatch:any) => {
    const d = await get<IHarm[]>(API_URL + "harms/" + params.toString() + "/", get_query());

    dispatch({
        type: 'set_harms',
        data: d
    })
}

export const getCommentThreads = async (params:string, dispatch:any) => {
    const d = await get<ICommentThread[]>(API_URL + "comment_thread/" + params + "/", get_query());

    dispatch({
        type: 'set_comment_threads',
        data: d
    })
}


export const getProjectAssessment = async (params:string, dispatch:any) => {
    const d = await get<IAssessmentProject>(API_URL + "assessment_project/" + params, get_query())
    // setAssessment(d);

    dispatch({
        type: 'set_projectAssessment',
        data: d
    })
}

export const getProjectAssessments = async (params:string, dispatch:any) => {
    const d = await get<IAssessment[]>(API_URL + "assessments/" + params + "/assessment", get_query());
    // setAssessments(assessments)

    dispatch({
        type: 'set_projectAssessments',
        data: d
    })
}


export const getTemplateGroups = async (project_id:number, dispatch:any) => {
    const d = await get<IAssessmentTemplateGroup[]>(API_URL + "assessment_templates/groups/"+ project_id +"/");
    // setTopLevelGroup(d);

    dispatch({
        type: 'set_templateGroups',
        data: d
    })

}

export const getTotalSummaryKnowledge = async (params:string, dispatch:any) => {
    const d = await get<ISummaryTotalKnowledge>(API_URL + "summary_assessment/" + params + "/summary", get_query());
    // setTotalSummary(assessments)

    dispatch({
        type: 'set_summaryTotalKnowledge',
        data: d
    })

}

export const getStates = async (params:string, dispatch:any) => {
    const d = await get<IState[]>(API_URL + "assessment_project/" + params + "/states");
    dispatch({
        type: 'set_states',
        data: d
    })
}

export const getConsequenceCategories = async (params:string, dispatch:any) => {
    const d = await get<IConsequenceCategory>(API_URL + "consequence_category/" + params + "/", get_query());

    dispatch({
        type: 'set_consequenceCategories',
        data: d
    })

}

export const getDocuments = async (params:string, dispatch:any) => {
    const d = await get<IDocument>(API_URL + "documents/" + params, get_query()) ;

    dispatch({
        type: 'set_documents',
        data: d
    })

}

const getProjectAccessLevel = async (params:string, dispatch:any) => {

    // get assessment project to get the project_id
    const assessmentProject = await get<IAssessmentProject>(API_URL + "assessment_project/" + params);

    // get the project user to get the access level

    const d = await get<IProjectUser>(API_URL + "projects/" + assessmentProject.dam?.project_id + "/my_role");

    dispatch({
        type: 'set_access_level',
        data: d.access_level
    })

    // check if query is empty
    if (Object.keys(get_query()).length > 0) {
        if(get_access()==="true") {
                dispatch({
                    type: 'set_write_access',
                    data: d.access_level >= 4
                })
            } else {
            dispatch({
                type: 'set_write_access',
                data: false
            })
        }

    } else  {

        dispatch({
            type: 'set_write_access',
            data: d.access_level >= 4
        })
    }
}




export let load_data = async (params:string, project_id:number, dispatch:any ) => {
    dispatch({
        type: 'set_loaded',
        data: false
    })

    let data = await Promise.all([
        getDataGaps(params, dispatch),
        getAdequacies(dispatch),
        getControlTypes(dispatch),
        getControlMeasureAdequacy(params, dispatch),
        getControlMeasures(params, dispatch),
        getFailureModes(params, dispatch),
        getFailureModeControlMeasures(params, dispatch),
        getFailureModeAssessments(params, dispatch),
        getControlMeasureAssessment(params, dispatch),
        getCriticalAssessments(params, dispatch),
        getControlMeasureCosts(params, dispatch),
        getSeverities(dispatch),
        getHarms(params, dispatch),
        getInvestigations(params, dispatch),
        getInvestigationAssessment(params, dispatch),
        getCriticalRiskAssessments(params, dispatch),
        getProjectAssessment(params, dispatch),
        getProjectAssessments(params, dispatch),
        getTemplateGroups(project_id, dispatch),
        getTotalSummaryKnowledge(params, dispatch),
        getAssessmentTemplates(project_id, dispatch),
        getStates(params, dispatch),
        getConsequenceCategories(params, dispatch),
        getDocuments(params, dispatch),
        getProjectAccessLevel(params, dispatch),
        getControlMeasureConcern(params, dispatch),
        getCommentThreads(params, dispatch),
        getAssessmentSettings(params, dispatch)
    ])

    dispatch({
        type: 'set_loaded',
        data: true
    })
}
